




































































































import DictMixin from '@/mixins/dict-mixin';
import MyTodoServices from '@/services/mytodo';
import SuperviseServices from '@/services/supervise';
import { mixins } from 'vue-class-component';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { exportBlobFile } from '@/libs/util';
import AlertDetail from '../todo/alert-detail.vue';
import AlertData from './alert-data.vue';
import ParamsServices from '@/services/params';
import MenuMixin from '@/mixins/menu-mixin';
import moment from 'moment';

@Component({
  components: { AlertDetail, AlertData }
})
export default class TaskList extends mixins(DictMixin, MenuMixin) {
  @Prop() list!: any;
  @Prop() total!: any;
  @Prop() loading!: boolean;
  @Prop() filter!: any;

  superSrv = new SuperviseServices();
  todoSrv = new MyTodoServices();

  columns = [
    { title: '预警消息', width: 300, dataIndex: 'alertMessage', fixed: 'left' },
    {
      title: '预警等级',
      dataIndex: 'alertLevel',
      width: 200,
      scopedSlots: {
        customRender: 'alertLevel'
      }
    },
    { title: '预警编号', width: 200, dataIndex: 'alertCode' },
    { title: '数据数量', width: 120, dataIndex: 'alertCount' },
    { title: '决策模型', width: 140, dataIndex: 'ruleName' },
    { title: '经办人/经办状态', width: 150, dataIndex: 'alertHandlerName', customRender: (text: string, record: any) => `${record.alertHandlerName || '未指定'} /${record.alertHandleStatusCn || ''}` },
    {
      title: '复核人/复核状态',
      width: 150,
      dataIndex: 'alertReviewStatusCn',
      customRender: (text: string, record: any) => `${record.alertReviewerName || '未指定'}/${record.alertReviewStatusCn || ''}`
    },
    { title: '监督人/监督状态', width: 150, dataIndex: 'inspectName', customRender: (text: string, record: any) => `${record.inspectName || '未指定'}/${record.alertInspectStatusCn || ''}` },
    { title: '预警日期', width: 150, dataIndex: 'alertDate' },
    { title: '经办期限', width: 150, dataIndex: 'alertHandleDueDate' },
    { title: '复核期限', width: 150, dataIndex: 'alertReviewDueDate' },
    { title: '经办日期', width: 150, dataIndex: 'handleDate' },
    { title: '复核日期', width: 150, dataIndex: 'reviewDate' },
    { title: '监督日期', width: 150, dataIndex: 'inspectDate' },
    { title: '管理板块', width: 100, dataIndex: 'ruleOwnerPlate', customRender: (text: string) => this.DICT_VALUE('DICT_BUSINESS_UNIT', text) },
    { title: '管理部门', width: 100, dataIndex: 'ruleOwnerDept', customRender: (text: string) => this.DICT_VALUE('DICT_BUSINESS_DEPT', text) },
    { title: '负责人', width: 100, dataIndex: 'ruleOwnerName' },
    { title: '决策大类', width: 100, dataIndex: 'ruleFirstLevel', customRender: (text: string) => this.DICT_VALUE('DICT_JOURNEY_SCENE', text) },
    { title: '决策中类', width: 100, dataIndex: 'ruleSecondLevel', customRender: (text: string) => this.DICT_VALUE('DICT_JOURNEY_SUB_SCENE', text) },
    { title: '决策小类', width: 100, dataIndex: 'ruleThirdLevel', customRender: (text: string) => this.DICT_VALUE('DICT_JOURNEY_SCENE_STEP', text) },
    { title: '决策集', width: 200, dataIndex: 'ruleSetName' },
    { title: '预警类型', width: 200, dataIndex: 'alertSourceTypeName' },
    { title: '电子邮件发送状态', width: 200, dataIndex: 'alertEmailStatusCn' },
    { title: '企业微信发送状态', width: 200, dataIndex: 'alertEwechatStatusCn' },
    {
      title: '操作',
      dataIndex: 'action',
      fixed: 'right',
      width: 230,
      scopedSlots: {
        customRender: 'action'
      }
    }
  ];

  visible: boolean = false;
  infos: any = {};
  logs: any = {};
  async openDetail(record: any) {
    let res = await this.todoSrv.getInfo(record.alertCode);
    this.infos = res.alertInfoSource || record;
    this.logs = res;
    this.visible = true;
  }

  dataVisible: boolean = false;
  async openAlertData(record: any) {
    this.infos = record;
    this.dataVisible = true;
  }

  detail: any = {};
  ignoreVisible: boolean = false;
  logInfo: string = '';
  isBatch: boolean = false;
  handleIgnore(record: any) {
    this.isBatch = false;
    this.detail = record;
    this.ignoreVisible = true;
  }
  submitIgnore() {
    if (!this.logInfo) {
      this.$message.error('请先输入忽略理由');
      return false;
    }
    let list: any = [];
    if (this.isBatch) {
      this.selectedRows.forEach((v: any) => {
        list.push({
          alertCode: v.alertCode,
          alertMessage: this.logInfo
        });
      });
    } else {
      list = [
        {
          alertCode: this.detail.alertCode,
          alertMessage: this.logInfo
        }
      ];
    }
    this.submitIgnoreBatch(list);
  }

  async submitIgnoreBatch(params: object[]) {
    let res = await this.superSrv.ignore(params);
    if (res) {
      this.$message.success('操作成功');
      this.ignoreVisible = false;
      this.logInfo = '';
      this.selectedRowKeys = [];
      this.$emit('reload');
    }
  }
  restartVisible: boolean = false;
  alertRestart: string = 'handle';
  handleUserType: string = 'keep';
  reviewUserType: string = 'keep';
  handleRestart(record: any) {
    this.isBatch = false;
    this.detail = record;
    this.restartVisible = true;
  }

  @Watch('ignoreVisible')
  @Watch('restartVisible')
  onVisibleChange() {
    this.alertRestart = 'handle';
    this.handleUserType = 'keep';
    this.reviewUserType = 'keep';
    this.logInfo = '';
    this.handleUserInfo = '';
    this.reviewUserInfo = '';
    this.handleUserId = '';
    this.handleUserName = '';
    this.reviewUserId = '';
    this.reviewUserName = '';
  }

  submitRestart() {
    if (!this.logInfo) {
      this.$message.error('请输入重启理由');
      return false;
    }
    let list: any = [];
    if (this.isBatch) {
      this.selectedRows.forEach((v: any) => {
        let alertHandlerId = v.alertHandlerId;
        let alertHandlerName = v.alertHandlerName;
        let alertReviewerId = v.alertReviewerId;
        let alertReviewerName = v.alertReviewerName;
        if (this.handleUserType === 'other') {
          if (!this.handleUserId) {
            this.$message.error('请经办选择人员');
            return false;
          }
          alertHandlerId = this.handleUserId;
          alertHandlerName = this.handleUserName;
        }
        if (this.reviewUserType === 'other') {
          if (!this.reviewUserId) {
            this.$message.error('请复核选择人员');
            return false;
          }
          alertReviewerId = this.reviewUserId;
          alertReviewerName = this.reviewUserName;
        }
        if (alertHandlerId === alertReviewerId) {
          this.$message.error('经办人与复核人不可为同一人');
          return false;
        }
        list.push({
          alertCode: v.alertCode,
          alertRestart: this.alertRestart,
          alertHandlerId,
          alertHandlerName,
          alertReviewerId,
          alertReviewerName,
          alertMessage: this.logInfo
        });
      });
    } else {
      let alertHandlerId = this.detail.alertHandlerId;
      let alertHandlerName = this.detail.alertHandlerName;
      let alertReviewerId = this.detail.alertReviewerId;
      let alertReviewerName = this.detail.alertReviewerName;

      if (this.handleUserType === 'other') {
        if (!this.handleUserId) {
          this.$message.error('请选择经办人员');
          return false;
        }
        alertHandlerId = this.handleUserId;
        alertHandlerName = this.handleUserName;
      }
      if (this.reviewUserType === 'other') {
        if (!this.reviewUserId) {
          this.$message.error('请选择复核人员');
          return false;
        }
        alertReviewerId = this.reviewUserId;
        alertReviewerName = this.reviewUserName;
      }
      if (alertHandlerId === alertReviewerId) {
        this.$message.error('经办人与复核人不可为同一人');
        return false;
      }

      list = [
        {
          alertCode: this.detail.alertCode,
          alertRestart: this.alertRestart,
          alertHandlerId,
          alertHandlerName,
          alertReviewerId,
          alertReviewerName,
          alertMessage: this.logInfo
        }
      ];
    }
    this.submitRestartBatch(list);
  }

  handleUserInfo: string = '';
  handleUserId: string = '';
  handleUserName: string = '';
  selectHandleUser(user: { userId: string; userName: string }) {
    this.handleUserId = user.userId;
    this.handleUserName = user.userName;
  }

  reviewUserInfo: string = '';
  reviewUserId: string = '';
  reviewUserName: string = '';
  selectReviewUser(user: { userId: string; userName: string }) {
    this.reviewUserId = user.userId;
    this.reviewUserName = user.userName;
  }

  async submitRestartBatch(params: object[]) {
    let res = await this.superSrv.restart(params);
    if (res) {
      this.$message.success('操作成功');
      this.restartVisible = false;
      this.logInfo = '';
      this.selectedRowKeys = [];
      this.$emit('reload');
    }
  }

  selectedRows: any[] = [];
  selectedRowKeys: any[] = [];
  onSelectChange(keys: any, rows: any) {
    this.selectedRowKeys = keys;
    this.selectedRows = rows;
  }

  handleBatch(e: any) {
    if (e.key === 'removeAll') {
      if (this.selectedRowKeys.length === 0) {
        this.$message.error('请选中至少一条数据');
        return false;
      }
      this.isBatch = true;
      this.ignoreVisible = true;
    }
    if (e.key === 'restartAll') {
      if (this.selectedRowKeys.length === 0) {
        this.$message.error('请选中至少一条数据');
        return false;
      }
      this.isBatch = true;
      this.restartVisible = true;
    }
  }

  excelLoading: boolean = false;
  async exportExcel() {
    let paramsSrv = new ParamsServices();
    let max = 10000;
    let list = await paramsSrv.getList({ paramCode_eq: 'PRM_MAX_EXCEL_EXPORT_COUNT' });
    if (list[0]) {
      max = parseInt(list[0].paramValue);
    }
    if (this.total > max) {
      this.$message.error(`预警记录件数超出系统阈值上限（${max}条），请限定预警查询条件范围。`);
      return false;
    }

    this.excelLoading = true;
    let data: string = await this.superSrv.downloadExcel(this.filter);
    const timestamp = moment().format('YYYYMMDD_HHmmss');
    exportBlobFile(`预警数据_${timestamp}.xlsx`, data);
    this.excelLoading = false;
  }

  bodyStyle = { backgroundColor: '#EEE' };
}
